/** Top: the top bar. The trail on the left; on the right the demo tag, freshness, point and comment (#717: pick anything on screen and say what is wrong with it), the bell (a link to Today, where the work is, dotted while someone waits) and Settings. */
import { useLocation } from "react-router-dom";
import { eventKey, getEvent } from "../data/events";
import { useQuery } from "../data/useQuery";
import type { Queues } from "../data/useQueues";
import { Badge, TopBar, TopBarButton, TopBarLink, Trail } from "../kit";
import { crumbs, eventRefIn } from "./crumbs";
import { DEMO } from "./demo";
import { Freshness } from "./Freshness";
import { href } from "./links";

/** What the bell says. No count: the sidebar's queues carry them, each opening its own list; never "all clear" before the queues have answered. */
function bell(queues: Queues): string {
  if (queues.loading) return "Needs you";
  if (queues.failed) return "Needs you: did not load";
  return queues.open > 0 ? "Needs you" : "Needs you: all clear";
}

export function Top({ queues, onPick }: { queues: Queues; onPick: () => void }) {
  const { pathname, search } = useLocation();
  // An event's page names the event in the trail: the page's own request, from the cache.
  const ref = eventRefIn(pathname);
  const event = useQuery(ref ? eventKey(ref) : null, () => getEvent(ref as string));
  return (
    <TopBar breadcrumb={<Trail items={crumbs(pathname, search, event.data?.event.name)} />}>
      {DEMO && <Badge className="max-sm:hidden">Demo data</Badge>}
      <Freshness />
      <TopBarButton label="Point and comment" icon="target" onClick={onPick} />
      <TopBarLink label={bell(queues)} icon="bell" motion="ring" href={href("/")} dot={queues.open > 0} />
      <TopBarLink label="Settings" icon="settings" motion="turn" href={href("/settings")} />
    </TopBar>
  );
}
